import { Injectable } from '@angular/core';
import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, catchError, EMPTY } from 'rxjs';
import { ErrorNotificationService } from '../services/error-notification.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private errorSvc: ErrorNotificationService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';

        switch (error.status) {
          case 403:
            this.showError('Access Denied. The request you are making seems suspisious or you do not have access to the requested resource!');
            break;
          case 404:
            this.showError('The resource you are attempting to access could not be found.  Please verify your links and try again!');
            break;
          default:
            this.showError('An unexpected error occured processing your request. Please contact the Public Document Room using the link in the Help & Info Menu.');
        }
        
        //Display a user friendly message
        return EMPTY;
      })
    );
  }

  showError(message: string) {
    this.errorSvc.notify(message);
    this.router.navigate(['/error']);
  }
}
